import { Command } from "lucide-react";
import { C, Panel, Kpi, Chip, Battery, Serif, Label } from "./ui";
import { REQUESTS } from "./adminData";

const PINS = [{ x: 42, y: 38 }, { x: 62, y: 55 }, { x: 30, y: 68 }];

export default function OpsConsole({ nav, product }) {
  const reqs = REQUESTS.filter((r) => product === "all" || r.product === product);
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 18 }}>
        <div>
          <Label>Live operations</Label>
          <Serif size={26} style={{ marginTop: 4 }}>Ops Console</Serif>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 12px", background: "#fff", border: "1px solid rgba(26,30,36,0.1)", borderRadius: 8, fontSize: 12, color: C.slate }}>
          <Command size={14} /> Press <b style={{ color: C.ink }}>⌘K</b> for command bar
        </div>
      </div>

      <div style={{ display: "flex", gap: 12, marginBottom: 18 }}>
        <Kpi label="Active now" value={reqs.length} accent={C.red} mono />
        <Kpi label="Today" value="12" mono />
        <Kpi label="Avg response" value="2m 14s" accent={C.green} mono />
        <Kpi label="SLA breaches" value="0" accent={C.green} mono />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "minmax(0,1fr) minmax(0,1.3fr)", gap: 16 }}>
        <div>
          <Label style={{ marginBottom: 10 }}>Incoming requests</Label>
          {reqs.map((r, i) => (
            <div key={r.id} onClick={() => nav("incident")} data-testid={`ops-request-${i}`}
              style={{ background: "#fff", border: `1px solid ${r.urgent ? C.red : "rgba(26,30,36,0.08)"}`, borderLeft: `3px solid ${r.urgent ? C.red : C.slate}`, borderRadius: 10, padding: 14, marginBottom: 10, cursor: "pointer" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: C.slate }}>{r.id}</span>
                <Chip color={r.type === "Medical" ? C.red : r.type === "Security" ? C.navy : C.amber}>{r.type}</Chip>
              </div>
              <div style={{ fontSize: 15, fontWeight: 700, color: C.ink }}>{r.name}</div>
              <div style={{ fontSize: 12, color: C.slate, fontFamily: "'JetBrains Mono', monospace", marginTop: 2 }}>{r.cell} · {r.partner}</div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                <Battery pct={r.battery} />
                <span style={{ fontSize: 12, fontWeight: 700, color: r.urgent ? C.red : C.slate, fontFamily: "'JetBrains Mono', monospace" }}>⏱ {r.elapsed}</span>
              </div>
            </div>
          ))}
        </div>

        <Panel style={{ padding: 0, overflow: "hidden" }}>
          <div style={{ position: "relative", height: 380, background: "linear-gradient(135deg,#1a2332,#0f1720)" }} data-testid="ops-map">
            <svg width="100%" height="100%" style={{ position: "absolute", inset: 0, opacity: 0.15 }}>
              <defs><pattern id="ogrid" width="38" height="38" patternUnits="userSpaceOnUse"><path d="M 38 0 L 0 0 0 38" fill="none" stroke="#5B6B7E" strokeWidth="0.5" /></pattern></defs>
              <rect width="100%" height="100%" fill="url(#ogrid)" />
            </svg>
            {reqs.map((r, i) => (
              <div key={r.id} style={{ position: "absolute", left: `${PINS[i].x}%`, top: `${PINS[i].y}%`, transform: "translate(-50%,-100%)" }}>
                <div style={{ width: 18, height: 18, background: r.urgent ? C.red : C.amber, borderRadius: "50% 50% 50% 0", transform: "rotate(-45deg)", boxShadow: `0 0 0 6px ${(r.urgent ? C.red : C.amber)}33`, animation: r.urgent ? "op 1.2s infinite" : "none" }} />
              </div>
            ))}
            <style>{`@keyframes op{0%,100%{opacity:1}50%{opacity:.5}}`}</style>
            <div style={{ position: "absolute", bottom: 12, left: 14, right: 14, background: "rgba(0,0,0,0.55)", borderRadius: 8, padding: 12, fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: "#fff", borderLeft: `3px solid ${C.green}` }}>
              <div>14:32:04 · Dispatched RSQ-2026-0042 · <span style={{ color: C.green }}>ETA 4 min</span></div>
              <div style={{ opacity: 0.6, marginTop: 3 }}>14:31:52 · PANIC received · Constantia, WC</div>
            </div>
          </div>
        </Panel>
      </div>
    </div>
  );
}
